import _slicedToArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createForOfIteratorHelper from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { isImmutable, denormalizeImmutable } from "../schemas/ImmutableUtils.js";
/**
 * Represents data that should be deduped by specifying a primary key.
 * @see https://resthooks.io/docs/api/Entity
 */

var Entity = /*#__PURE__*/function () {
  function Entity() {
    _classCallCheck(this, Entity);
  }

  _createClass(Entity, null, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        name: this.name,
        schema: this.schema,
        key: this.key
      };
    }
    /** Defines nested entities */

    /** Returns the globally unique identifier for the static Entity */

  }, {
    key: "key",
    get: function get() {
      /* istanbul ignore next */
      if (process.env.NODE_ENV !== 'production' && (this.name === '' || this.name === 'Entity' || this.name === '_temp')) throw new Error('Entity classes without a name must define `static get key()`');
      return this.name;
    }
    /** Defines indexes to enable lookup by */

    /**
     * A unique identifier for each Entity
     *
     * @param [value] POJO of the entity or subset used
     * @param [parent] When normalizing, the object which included the entity
     * @param [key] When normalizing, the key where this entity was found
     */

  }, {
    key: "pk",
    value: function pk(value, parent, key) {
      return this.prototype.pk.call(value, parent, key);
    }
    /** Creates new instance copying over defined values of arguments */

  }, {
    key: "merge",
    value: function merge(existing, incoming) {
      return _objectSpread(_objectSpread({}, existing), incoming);
    }
    /** Factory method to convert from Plain JS Objects.
     *
     * @param [props] Plain Object of properties to assign.
     * @param [parent] When normalizing, the object which included the record
     * @param [key] When normalizing, the key where this record was found
     */

  }, {
    key: "fromJS",
    value: function fromJS() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // we type guarded abstract case above, so ok to force typescript to allow constructor call
      var instance = new this(props); // we can't rely on constructors and override the defaults provided as property assignments
      // all occur after the constructor

      Object.assign(instance, props);
      return instance;
    }
    /** Do any transformations when first receiving input */

  }, {
    key: "process",
    value: function (_process) {
      function process(_x, _x2, _x3) {
        return _process.apply(this, arguments);
      }

      process.toString = function () {
        return _process.toString();
      };

      return process;
    }(function (input, parent, key) {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== 'production' && this.automaticValidation !== 'silent') {
        if (Array.isArray(input)) {
          var errorMessage = "Attempted to initialize ".concat(this.name, " with an array, but named members were expected\n\nThis is likely due to a malformed response.\nTry inspecting the network response or fetch() return value.\nOr use debugging tools: https://resthooks.io/docs/guides/debugging\nLearn more about schemas: https://resthooks.io/docs/api/schema\nIf this is a mistake, you can disable this check by setting static automaticValidation = 'silent'\n\nFirst three members: ").concat(JSON.stringify(input.slice(0, 3), null, 2));

          if (this.automaticValidation !== 'warn') {
            var error = new Error(errorMessage);
            error.status = 400;
            throw error;
          }

          console.warn(errorMessage);
        }
      }

      return _objectSpread({}, input);
    })
  }, {
    key: "normalize",
    value: function normalize(input, parent, key, visit, addEntity, visitedEntities) {
      var _this = this;

      var processedEntity = this.process(input, parent, key);
      var id = this.pk(processedEntity, parent, key);

      if (id === undefined || id === '') {
        if (process.env.NODE_ENV !== 'production') {
          var error = new Error("Missing usable primary key when normalizing response.\n\n  This is likely due to a malformed response.\n  Try inspecting the network response or fetch() return value.\n  Or use debugging tools: https://resthooks.io/docs/guides/debugging\n  Learn more about schemas: https://resthooks.io/docs/api/schema\n\n  Entity: ".concat(this.name, "\n  Value (processed): ").concat(processedEntity && JSON.stringify(processedEntity, null, 2), "\n  "));
          error.status = 400;
          throw error;
        } else {
          // these make the keys get deleted
          return undefined;
        }
      }

      var entityType = this.key;

      if (!(entityType in visitedEntities)) {
        visitedEntities[entityType] = {};
      }

      if (!(id in visitedEntities[entityType])) {
        visitedEntities[entityType][id] = [];
      }

      if (visitedEntities[entityType][id].some(function (entity) {
        return entity === input;
      })) {
        return id;
      }

      var errorMessage = this.validate(processedEntity);

      if (errorMessage) {
        var _error = new Error(errorMessage);

        _error.status = 400;
        throw _error;
      }

      visitedEntities[entityType][id].push(input);
      Object.keys(this.schema).forEach(function (key) {
        if (Object.prototype.hasOwnProperty.call(processedEntity, key)) {
          var schema = _this.schema[key];
          processedEntity[key] = visit(processedEntity[key], processedEntity, key, schema, addEntity, visitedEntities);
        }
      });
      addEntity(this, processedEntity, id);
      return id;
    }
  }, {
    key: "validate",
    value: function validate(processedEntity) {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== 'production' && this.automaticValidation !== 'silent') {
        var keysOfRecord = new Set(Object.keys(this.defaults));
        var keysOfProps = Object.keys(processedEntity);
        var found = [],
            missing = [],
            unexpected = [];

        for (var _i = 0, _keysOfProps = keysOfProps; _i < _keysOfProps.length; _i++) {
          var keyOfProps = _keysOfProps[_i];

          if (keysOfRecord.has(keyOfProps)) {
            found.push(keyOfProps);
          } else {
            unexpected.push(keyOfProps);
          }
        }

        var _iterator = _createForOfIteratorHelper(keysOfRecord),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var keyOfRecord = _step.value;

            if (!found.includes(keyOfRecord)) {
              missing.push(keyOfRecord);
            }
          } // only bother with this if they used *any* defaults

        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (keysOfRecord.size) {
          var tooManyUnexpected = // unexpected compared to members in response
          Math.max(keysOfProps.length / 2, 1) <= unexpected.length && // unexpected compared to what we specified
          keysOfRecord.size > Math.max(unexpected.length, 2) && // as we find more and more be more easily assured it is correct
          Math.pow(found.length, 1.5) / 2 <= unexpected.length;
          var foundNothing = found.length < Math.min(1, keysOfRecord.size / 2); // if we find nothing (we expect at least one member for a pk)
          // or we find too many unexpected members

          if (tooManyUnexpected || foundNothing) {
            var extra = '';
            var reason = 'substantially different than expected keys';

            if (foundNothing) {
              extra += "\n    Missing: ".concat(missing);
              reason = 'no matching keys found';
            }

            if (tooManyUnexpected) {
              extra += "\n    Unexpected keys: ".concat(unexpected);
              reason = 'a large number of unexpected keys found';
            }

            var errorMessage = "Attempted to initialize ".concat(this.name, " with ").concat(reason, "\n\n  This is likely due to a malformed response.\n  Try inspecting the network response or fetch() return value.\n  Or use debugging tools: https://resthooks.io/docs/guides/debugging\n  Learn more about schemas: https://resthooks.io/docs/api/schema\n  If this is a mistake, you can disable this check by setting static automaticValidation = 'silent'\n\n  Expected keys:\n    Found: ").concat(found).concat(extra, "\n  Value (processed): ").concat(JSON.stringify(processedEntity, null, 2));

            if (found.length >= 4 && tooManyUnexpected || this.automaticValidation === 'warn') {
              console.warn(errorMessage);
            } else {
              return errorMessage;
            }
          }
        }
      }

      if (process.env.NODE_ENV !== 'production') {
        for (var _i2 = 0, _Object$keys = Object.keys(this.schema); _i2 < _Object$keys.length; _i2++) {
          var key = _Object$keys[_i2];

          if (!Object.prototype.hasOwnProperty.call(processedEntity, key)) {
            if (!Object.prototype.hasOwnProperty.call(this.defaults, key)) {
              return "Schema key is missing in Entity\n\n  Be sure all schema members are also part of the entity\n  Or use debugging tools: https://resthooks.io/docs/guides/debugging\n  Learn more about nesting schemas: https://resthooks.io/docs/guides/nested-response\n\n  Entity keys: ".concat(Object.keys(this.defaults), "\n  Schema key(missing): ").concat(key, "\n  ");
            }
          }
        }
      }
    }
  }, {
    key: "infer",
    value: function infer(args, indexes, recurse) {
      if (!args[0]) return undefined;
      var id = this.pk(args[0], undefined, ''); // Was able to infer the entity's primary key from params

      if (id !== undefined && id !== '') return id; // now attempt lookup in indexes

      var indexName = indexFromParams(args[0], this.indexes);

      if (indexName && indexes[this.key]) {
        // 'as Record<string, any>': indexName can only be found if params is a string key'd object
        var _id = indexes[this.key][indexName][args[0][indexName]];
        return _id;
      }

      return undefined;
    }
  }, {
    key: "expiresAt",
    value: function expiresAt(meta, input) {
      return meta.expiresAt;
    }
  }, {
    key: "denormalize",
    value: function denormalize(input, unvisit) {
      var _this2 = this;

      if (isImmutable(input)) {
        if (this.validate(input.toJS())) return [undefined, false, true]; // Need to set this first so that if it is referenced further within the
        // denormalization the reference will already exist.

        unvisit.setLocal == null ? void 0 : unvisit.setLocal(input);

        var _denormalizeImmutable = denormalizeImmutable(this.schema, input, unvisit),
            _denormalizeImmutable2 = _slicedToArray(_denormalizeImmutable, 3),
            denormEntity = _denormalizeImmutable2[0],
            found = _denormalizeImmutable2[1],
            _deleted = _denormalizeImmutable2[2];

        return [this.fromJS(denormEntity.toObject()), found, _deleted];
      }

      if (this.validate(input)) {
        return [undefined, false, true];
      }

      var entityCopy = this.fromJS(input); // Need to set this first so that if it is referenced further within the
      // denormalization the reference will already exist.

      unvisit.setLocal == null ? void 0 : unvisit.setLocal(entityCopy);
      var deleted = false; // note: iteration order must be stable

      Object.keys(this.schema).forEach(function (key) {
        var schema = _this2.schema[key];
        var nextInput = Object.prototype.hasOwnProperty.call(input, key) ? input[key] : undefined;

        var _unvisit = unvisit(nextInput, schema),
            _unvisit2 = _slicedToArray(_unvisit, 3),
            value = _unvisit2[0],
            deletedItem = _unvisit2[2];

        if (deletedItem && !(Object.prototype.hasOwnProperty.call(input, key) && !_this2.defaults[key])) {
          deleted = true;
        }

        if (Object.prototype.hasOwnProperty.call(input, key) && input[key] !== value) {
          _this2.set(entityCopy, key, value);
        }
      });
      return [entityCopy, true, deleted];
    }
    /** All instance defaults set */

  }, {
    key: "defaults",
    get: function get() {
      if (!Object.prototype.hasOwnProperty.call(this, '__defaults')) this.__defaults = new this();
      return this.__defaults;
    }
    /** Used by denormalize to set nested members */

  }, {
    key: "set",
    value: function set(entity, key, value) {
      entity[key] = value;
    }
  }]);

  return Entity;
}();
/* istanbul ignore else */


export { Entity as default };
Entity.schema = {};

if (process.env.NODE_ENV !== 'production') {
  var superFrom = Entity.fromJS; // for those not using TypeScript this is a good catch to ensure they are defining
  // the abstract members

  Entity.fromJS = function fromJS(props) {
    if (this.prototype.pk === undefined) throw new Error('cannot construct on abstract types');
    return superFrom.call(this, props);
  };
}

export function isEntity(schema) {
  return schema !== null && schema.pk !== undefined;
}

function indexFromParams(params, indexes) {
  if (!indexes) return undefined;
  return indexes.find(function (index) {
    return Object.prototype.hasOwnProperty.call(params, index);
  });
}